export default __webpack_public_path__ + "static/media/logo.c2009a26.svg";